// extracted by mini-css-extract-plugin
export var content = "_dy-3";
export var list = "_dy-4";
export var settingsContent = "_dy-7";
export var settingsPanel = "_dy-8";
export var state = "_dy-6";
export var triggerBadge = "_dy-2";
export var triggerButton = "_dy-1";
export var triggerShell = "_dy-0";
export var unreadDot = "_dy-5";